import angular from 'angular';
import swoaCardCardYearService from '../card-year/card-year.service';

export default angular
  .module('swoa.card.card-year', [
    swoaCardCardYearService,
  ])
  .name;

